<script context="module" lang="ts">export { specification } from "./spec";
</script>
  
<script lang="ts">import { uniqueId } from "lodash";
import { onMount } from 'svelte';
import { t } from "js/i18n";
import BaseAtom from 'components/cards/atoms/BaseAtom.svelte';
import { getSEOManager } from 'components/cards/atoms';
import { VideoParticle } from 'components/cards/particles/YinzCam';
import TextParticle from 'components/cards/particles/YinzCam/Core/Text/TextParticle.svelte';
import RichTextParticle from "components/cards/particles/YinzCam/Core/RichText/RichTextParticle.svelte";
import { getPublishDuration, getVideoPlaybackToken, handleVideoError, handleVideoReady } from "components/cards/utilities";
import ImageParticle from "components/cards/particles/YinzCam/Core/Image/ImageParticle.svelte";
import { JanusSEOPriority } from "js/seo";
import { onDestroy } from "svelte";
export let container = undefined;
export let slug = undefined;
export let link = undefined;
export let imageUrl = undefined;
export let publishDateTime = undefined;
export let titleText = undefined;
//export let descriptionText: TextParticleProps = undefined;
export let dateTimeText = undefined;
export let video = undefined;
export let showInfoBox = undefined;
export let imgClockIcon = undefined;
export let setPageMetadata = undefined;
export let showOverlay = undefined;
export let overlayPassthrough = true;
export let overlay = undefined;
let atomWidthRem;
$: publishDateTimeDisplay = getPublishDuration(publishDateTime, $t);
let videoEl;
onMount(() => {
    return () => {
        if (videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
        }
    };
});
const seoManager = getSEOManager();
const seoConfigKey = uniqueId();
$: if (setPageMetadata && (titleText === null || titleText === void 0 ? void 0 : titleText.text)) {
    seoManager.registerSEOConfiguration(Object.assign({ key: seoConfigKey, priority: JanusSEOPriority.Card, isPopup: false, title: titleText.text }, (imageUrl && { imageUrl })));
}
onDestroy(() => {
    seoManager.unregisterSEOConfiguration(seoConfigKey);
});
</script>

<style>
  div.outer {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  div.player {
    max-width: 100%;
  }

  div.info-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1.75rem 0;
    gap: 0.5rem;
  }
  .info-box-date{
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .overlay.interactive {
    pointer-events: auto;
  }</style>

<BaseAtom _isotope="VideoPlayerAtom" {...container} bind:_clientWidthRem={atomWidthRem}>
  <div class="outer">
    {#if showOverlay}
    <div class="overlay" class:interactive={!overlayPassthrough}>
      <RichTextParticle {...overlay} />
    </div>
    {/if}
    <div class="player">
      <VideoParticle on:ready={handleVideoReady} on:error={(e) => handleVideoError(e, slug)} _getPlaybackToken={getVideoPlaybackToken} {...video}  />
    </div>
    {#if showInfoBox && (titleText?.text || publishDateTime)}
    <div class="info-box">
      {#if titleText?.text}
      <div class="info-box-title">
        <TextParticle {...titleText} />
      </div>
      {/if}
      {#if publishDateTime}
      <div class="info-box-date">
        <div>
          <ImageParticle {...imgClockIcon} _block={true}/>
        </div>
        <div>
          <TextParticle {...dateTimeText} text={publishDateTimeDisplay} _block={true}/>
        </div>
      </div>
      {/if}
    </div>
    {/if}
  </div>
</BaseAtom>

